module.exports = __webpack_public_path__ + "img/ics_o_profile.6e26e364.svg";